import * as React from "react";

import { componentCategories, components } from "../_Generated/Pages";
import { ComponentTiles } from "../Components/ComponentTiles";

export default class ComponentsPage extends React.Component {
    public render(): JSX.Element | null {
        return (
            <div className="flex-column flex-grow">
                <h1 className="page-title">Utilities</h1>
                <ComponentTiles
                    components={components}
                    categories={componentCategories.filter(c => c.page === "utilities")}
                    searchPlaceholder="Search utilities"
                />
            </div>
        );
    }
}
